// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PT8V8","note":"styles_note__LlIhQ"};